var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否通过",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "综合能力",
      "required": ""
    }
  }, _vm._l((_vm.scoreMapList.slice(0, 6)), function(scoreMapItem) {
    return _c('el-row', {
      key: scoreMapItem.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(scoreMapItem.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-radio-group', {
      ref: scoreMapItem.prop,
      refInFor: true,
      staticClass: "score-group",
      model: {
        value: (_vm.form[scoreMapItem.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, scoreMapItem.prop, $$v)
        },
        expression: "form[scoreMapItem.prop]"
      }
    }, _vm._l((5), function(n) {
      return _c('el-radio', {
        key: n,
        staticClass: "score-item",
        attrs: {
          "label": n + ''
        }
      }, [_vm._v(_vm._s(n))])
    }), 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "个人素质",
      "required": ""
    }
  }, _vm._l((_vm.scoreMapList.slice(6, 9)), function(scoreMapItem) {
    return _c('el-row', {
      key: scoreMapItem.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(scoreMapItem.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-radio-group', {
      ref: scoreMapItem.prop,
      refInFor: true,
      staticClass: "score-group",
      model: {
        value: (_vm.form[scoreMapItem.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, scoreMapItem.prop, $$v)
        },
        expression: "form[scoreMapItem.prop]"
      }
    }, _vm._l((5), function(n) {
      return _c('el-radio', {
        key: n,
        staticClass: "score-item",
        attrs: {
          "label": n + ''
        }
      }, [_vm._v(_vm._s(n))])
    }), 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '12' && _vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "专业能力",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "professionalProjMgr",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "（重点考察：计划制定、进度跟进、风险管理、干系人管理、团队配合情况等）",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.professionalProjMgr),
      callback: function($$v) {
        _vm.$set(_vm.form, "professionalProjMgr", $$v)
      },
      expression: "form.professionalProjMgr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '13' && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "专业能力",
      "required": ""
    }
  }, _vm._l((_vm.skillMapList), function(skillMap) {
    return _c('el-row', {
      key: skillMap.name
    }, [_c('el-col', {
      staticClass: "inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(skillMap.name))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      ref: skillMap.prop,
      refInFor: true,
      staticClass: "text-content",
      attrs: {
        "maxlength": 2000,
        "placeholder": skillMap.placeholder,
        "type": "textarea"
      },
      model: {
        value: (_vm.form[skillMap.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, skillMap.prop, $$v)
        },
        expression: "form[skillMap.prop]"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "其他",
      "required": ""
    }
  }, _vm._l((_vm.otherMapList), function(otherMap) {
    return _c('el-row', {
      key: otherMap.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td",
      class: {
        'required': otherMap.required
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(otherMap.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      ref: otherMap.prop,
      refInFor: true,
      staticClass: "text-content",
      attrs: {
        "maxlength": 500,
        "placeholder": "请输入"
      },
      model: {
        value: (_vm.form[otherMap.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, otherMap.prop, $$v)
        },
        expression: "form[otherMap.prop]"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType)) ? _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放16个月则填写：16",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利补充")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "根据候选人实际要求填写即可，请尽可能详细；如年薪XX万、月薪6k*13",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '11') ? _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "最快到岗时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    ref: "lastEntryTime",
    attrs: {
      "align": "left",
      "editable": false,
      "valueFormat": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.form.lastEntryTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "lastEntryTime", $$v)
      },
      expression: "form.lastEntryTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0fa8f4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-pma.vue
// module id = null
// module chunks = 